import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import miruna from "../assets/succes/miruna.jpeg";

function MirunaStory() {
  const { t } = useTranslation("adopt");

  return (
    <div className="home-project-card miruna-story">
      <motion.img
        src={miruna}
        alt="Story Miruna"
        className="home-project-image"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      />

      <div className="home-project-content">
        <h3>{t("stories.miruna.name")}</h3>
        <p className="home-project-full">{t("stories.miruna.text1")}</p>
        <p className="home-project-full">{t("stories.miruna.text2")}</p>
        <p className="home-project-full">{t("stories.miruna.text3")}</p>
      </div>
    </div>
  );
}

export default MirunaStory;
